<template>
  <Pie :data="data" :options="options" />
</template>

<script>
  import { Pie } from 'vue-chartjs';
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale,
  } from 'chart.js';
  ChartJS.register(CategoryScale, ArcElement, Title, Tooltip, Legend);
  export default {
    components: { Pie },
    props: {
      poll: {
        type: Object,
        required: true,
      },
      polllabelarray: {
        type: Array,
        required: true,
      },
      polldata: {
        type: Array,
        required: true,
      },

    },
    data: function () {
      return {
        data: {
          labels: this.polllabelarray,
          datasets: [
            {
              label: this.poll.poll_question,
              backgroundColor: [
                '#006742',
                '#5AB5A2',
                '#17355C',
                '#65A9D2',
                '#EB5757',
                '#DBDCDE',
              ],
              // fill: false,
              // borderColor: "#17355C",
              // pointRadius: 0,
              data: this.polldata,
              // yAxisID: 'A',
            },
          ],
        },
        options: {
          plugins: {
            legend: {
              position: 'right',
              labels: {
                fontSize: 22,
                fontFamily: 'sans-serif',
                padding: 18,
                usePointStyle: true,

                // This more specific font property overrides the global property
                //fontColor: 'black'
              },
            },
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 10,
              bottom: 0,
            },
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      };
    },
  };
</script>
